export default __webpack_public_path__ + "static/media/2022-91 Хувьсах зардал.015cf522.pdf";